import {commonService} from "./common.services";
export  const pageService = {
    loginUser,
    logoutUser,
    activityLog,
    resetPassword

}

function loginUser(data) {
    return commonService.sendHttpRequest('login/checklogin', data, "POST");
}
function logoutUser(data) {
    return commonService.sendHttpRequest('login/logout', data, "POST");
}
function resetPassword(data) {
    return commonService.sendHttpRequest('vgallery/resetemail', data, "POST");
}
function activityLog(data) {
    return commonService.sendHttpRequest('login/loglastactivity', data, "GET");
}


// WEBPACK FOOTER //
// ./src/services/pages.services.js